import React, { useState, useEffect, useCallback } from 'react';
import { Field } from "formik";
import { useDispatch } from "react-redux";
import RadioButton from "web/components/form-elements/RadioButton";
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import Select from 'web/components/form-elements/Select';
import NumberInput from 'web/components/form-elements/NumberInput';
import UploadDummy from 'web/assets/images/UploadDummy.png'
import styled from 'styled-components';
import { palletDetails } from "redux/actions/postLoad";
import UploadSpecification from "web/components/UploadSpecification";
import { uploadSpec } from "redux/actions/postLoad";

const PalletSpecDetails = ({ ...props }) => {
    const dispatch = useDispatch();

    const formikProps = props.formikValues
    const [palletSpecificationDetails, setPalletSpecificationDetails] = useState()

    const conditionOptionsWood = [{ value: "recycled", label: 'Recycled' }, { value: "newCondition", label: 'New' }, { value: "combo", label: 'Combo' }, { value: "cores", label: 'Cores' }]
    const conditionOptionsPlastic = [{ value: "recycled", label: 'Recycled' }, { value: "newCondition", label: 'New' }]
    const [conditionOptions, setConditionOptions] = useState(conditionOptionsWood)
    const materialOptions = [{ value: "wood", label: 'Wood' }, { value: "plastic", label: 'Plastic' }, { value: "other", label: 'Other' }]
    let newOrRecycledPalletList = [{ label: "Block", value: "block", }, { label: "Stringer", value: "stringer", }, { label: "Euro Pallet", value: "euroPallet", }, { label: "Crate", value: "crate", }, { label: "Tray", value: "tray", }, { label: "Other", value: "other", }]
    let comboPalletList = [{ label: "Stringer", value: "stringer", }, { label: "Crate", value: "crate", }, { label: "Custom", value: "custom", }]
    let coresPalletList = [{ label: "Block", value: "block", }, { label: "Stringer", value: "stringer", }]

    const [editFlag, setEditFlag] = useState(false)
    const [palletTypeList, setPalletTypeList] = useState([])
    const [moistureList, setmoistureList] = useState([])
    const [sizeList, setSizeList] = useState([])
    const [gradeList, setGradeList] = useState([])
    const [defaultSpecFile, setDefaultSpecFile] = useState()
    const [uploadedSpecFileArr, setUploadedSpecFileArr] = useState()
    let fileArr = []

    useEffect(() => {
        fetchPalletSpecDetails()

        if (props?.editResponse?.palletDetails) {
            if (props?.editResponse?.palletDetails?.condition && props?.editResponse?.palletDetails?.condition !== 0) {
                // formikProps.setFieldValue('conditionRadioValue',props?.editResponse?.palletDetails?.condition[0])
                if (props?.editResponse?.palletDetails?.condition[0] === 'RECYCLED' || props?.editResponse?.palletDetails?.condition[0] === 'NEW') setPalletTypeList(newOrRecycledPalletList)
                else if (props?.editResponse?.palletDetails?.condition[0] === 'COMBO') setPalletTypeList(comboPalletList)
                else if (props?.editResponse?.palletDetails?.condition[0] === 'CORES') setPalletTypeList(coresPalletList)
            }
        }
    }, [props?.editResponse])

    useEffect(() => {
        updateSpecFileState()
    }, [defaultSpecFile, uploadedSpecFileArr])

    const updateSpecFileState = async () => {
        let specificationFileList
        if (uploadedSpecFileArr) {
            props.setPalletSpecFilesData(uploadedSpecFileArr)
            let formData = new FormData();
            uploadedSpecFileArr.map((data) => formData.append("uploadSpecification", data))
            let response = await dispatch(uploadSpec(formData, ''));
            if (response.status === "SUCCESS") {
                specificationFileList = response.payload
            } else return
        } else if (defaultSpecFile) {
            specificationFileList = [{ orignalFileName: defaultSpecFile[0].value, fileName: defaultSpecFile[0].value }]
        }
        if (specificationFileList) props.setPalletSpecFilesData(specificationFileList)
    }

    const fetchPalletSpecDetails = async () => {
        const token = localStorage.getItem('token')
        let response = await dispatch(palletDetails(token));
        if (response.success) {
            setPalletSpecificationDetails(response.data)

            if (props?.editResponse) {
                setEditFlag(true)
                props.setPalletSpecFilesData(props?.editResponse?.specificationFiles)
                palletTypeSelectionFunction(formikProps.values, formikProps.setFieldValue, props?.editResponse?.palletDetails?.palletType, response.data, true)
            }


        } else setPalletSpecificationDetails()
    }

    let hardOrSoftWoodArray = ['New - Hardwood', 'New - Softwood']
    const [hardOrSoftWoodValue, setHardOrSoftWoodValue] = useState('')

    const resetFieldValues = (setFieldValue, type, editFlag) => {
        const { touched, setTouched } = formikProps
        const newTouched = { ...touched }
        delete newTouched['length']
        delete newTouched['width']
        delete newTouched['height']
        delete newTouched['palletType']
        delete newTouched['grade']
        setTouched(newTouched)
        setGradeList([])
        setFieldValue('grade', '')
        setFieldValue('length', '')
        setFieldValue('width', '')
        setFieldValue('height', '')
        setFieldValue('heatTreated', false)
        setFieldValue('showHeatTreated', false)
        setFieldValue('isGradeAvailable', false)
        if (formikProps.values?.materialRadioValue === 'plastic') {
            setFieldValue('quantityMaxValue', 786)
        } else {
            setFieldValue('quantityMaxValue', 540)
        }
        if (editFlag && props.editResponse?.lotDetails?.originalQty) {
            setFieldValue('quantityMaxValue', props.editResponse?.lotDetails?.originalQty)
        }
        setDefaultSpecFile()
        if (!editFlag) props.defaultPostImageCallBack()
        setUploadedSpecFileArr()
        if (type === 'all') {
            delete newTouched['palletType']
            delete newTouched['size']
            delete newTouched['moisture']
            setTouched(newTouched)
            setPalletTypeList([])
            setmoistureList([])
            setSizeList([])
            setFieldValue('palletType', '')
            setFieldValue('moisture', '')
            setFieldValue('isMoistureAvailable', false)
            setFieldValue('size', '')
            setFieldValue('isSizeAvailable', false)
        } else if (type === 'withoutPalletType') {
            delete newTouched['size']
            delete newTouched['moisture']
            setTouched(newTouched)
            setmoistureList([])
            setSizeList([])
            setFieldValue('moisture', '')
            setFieldValue('isMoistureAvailable', false)
            setFieldValue('size', '')
            setFieldValue('isSizeAvailable', false)
        } else if (type === 'withoutPalletTypeAndMoisture') {
            delete newTouched['size']
            setTouched(newTouched)
            setSizeList([])
            setFieldValue('size', '')
            setFieldValue('isSizeAvailable', false)
        } else if (type === 'withoutPalletTypeMoistureAndSize') {
        }
    }

    const materialSelectFunction = (setFieldValue, materialValue) => {
        setEditFlag(false)
        props.setPalletSpecFilesData()
        setFieldValue('quantityPerLot', 540)
        resetFieldValues(setFieldValue, 'all')
        setFieldValue('conditionRadioValue', '')
        if (materialValue === 'plastic') {
            setFieldValue('quantityMaxValue', 786)
            setFieldValue('quantityPerLot', 786)
        } else {
            setFieldValue('quantityMaxValue', 540)
            setFieldValue('quantityPerLot', 540)
        }
        if (materialValue === 'wood') setConditionOptions(conditionOptionsWood)
        else if (materialValue === 'plastic') setConditionOptions(conditionOptionsPlastic)
        else if (materialValue === 'other') setConditionOptions([])
    }


    const conditionSelectFunction = (setFieldValue, conditionValue) => {
        setEditFlag(false)
        props.setPalletSpecFilesData()
        resetFieldValues(setFieldValue, 'all')
        if (conditionValue === 'recycled' || conditionValue === 'newCondition') setPalletTypeList(newOrRecycledPalletList)
        else if (conditionValue === 'combo') setPalletTypeList(comboPalletList)
        else if (conditionValue === 'cores') setPalletTypeList(coresPalletList)
    }

    const palletTypeSelectionFunction = (formikValues, setFieldValue, palletTypeValue, palletSpecificationData, editFlag) => {
        resetFieldValues(setFieldValue, 'withoutPalletType', editFlag)

        if (!editFlag) setEditFlag(false)
        let conditionRadioValue = formikValues.conditionRadioValue
        if (props?.editResponse?.palletDetails?.condition && editFlag) {
            if (props?.editResponse?.palletDetails?.condition[0] === 'RECYCLED') conditionRadioValue = 'recycled'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'NEW') conditionRadioValue = 'newCondition'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'COMBO') conditionRadioValue = 'combo'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'CORES') conditionRadioValue = 'cores'
            else {
                conditionRadioValue = ''
            }
        }
        let palletType = palletTypeValue?.value
        if (props?.editResponse?.palletDetails?.palletType && editFlag) {
            if (props?.editResponse?.palletDetails?.palletType === "Euro Pallet" || props?.editResponse?.palletDetails?.palletType === "EUROPALLET") {
                palletType = 'euroPallet'
            } else {
                palletType = props?.editResponse?.palletDetails?.palletType.toLowerCase()
            }
        }
        let materialRadioValue = formikValues.materialRadioValue
        if (props?.editResponse?.palletDetails?.material && editFlag) {
            materialRadioValue = props?.editResponse?.palletDetails?.material.toLowerCase()
        }

        if (props?.editResponse?.palletDetails?.material && editFlag) {
            // materialSelectFunction(setFieldValue, props?.editResponse?.palletDetails?.material.toLowerCase())
            if (props?.editResponse?.palletDetails?.material.toLowerCase() === 'wood') setConditionOptions(conditionOptionsWood)
            else if (props?.editResponse?.palletDetails?.material.toLowerCase() === 'plastic') setConditionOptions(conditionOptionsPlastic)
            else if (props?.editResponse?.palletDetails?.material.toLowerCase() === 'other') setConditionOptions([])
        }

        if (props?.editResponse?.palletDetails?.height && editFlag)
            setFieldValue("height", props?.editResponse?.palletDetails?.height)
        if (props?.editResponse?.palletDetails?.width && editFlag)
            setFieldValue("width", props?.editResponse?.palletDetails?.width)
        if (props?.editResponse?.palletDetails?.length && editFlag)
            setFieldValue("length", props?.editResponse?.palletDetails?.length)
        if ((palletSpecificationDetails || palletSpecificationData) && conditionRadioValue) {
            let tempSpecDetails
            if (palletSpecificationData && editFlag)
                tempSpecDetails = palletSpecificationData[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails
            else tempSpecDetails = palletSpecificationDetails[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails

            let tempMoistureList = tempSpecDetails?.filter(val => (val.moisture && val.moisture !== '')).map(val => val.moisture)
            let tempSizeList = tempSpecDetails?.filter(val => (val.size && val.size !== '')).map(val => val.size)

            if (tempMoistureList && tempMoistureList?.length > 0) {
                setFieldValue('isMoistureAvailable', true)
                tempMoistureList = new Set(tempMoistureList)
                tempMoistureList = Array.from(tempMoistureList)
                tempMoistureList = tempMoistureList.map(data => ({ label: data, value: data }))
                setmoistureList(tempMoistureList)

                if (props?.editResponse?.palletDetails?.moisture && editFlag) {
                    setFieldValue("moisture", props?.editResponse?.palletDetails?.moisture)
                    moistureSelectionFunction(formikProps.values, formikProps.setFieldValue, props?.editResponse?.palletDetails?.moisture, palletSpecificationData, editFlag)
                }

            } else if (tempSizeList && tempSizeList?.length > 0) {
                setFieldValue('isSizeAvailable', true)
                tempSizeList = new Set(tempSizeList)
                tempSizeList = Array.from(tempSizeList)
                tempSizeList = tempSizeList.map(data => ({ label: data, value: data }))
                setSizeList(tempSizeList)

                if (props?.editResponse?.palletDetails?.size && editFlag) {
                    setFieldValue("size", props?.editResponse?.palletDetails?.size)
                    sizeSelectionFunction(formikProps.values, formikProps.setFieldValue, props?.editResponse?.palletDetails?.size, palletSpecificationData, editFlag)
                }

            } else if (palletTypeValue?.value === 'custom') {
                setFieldValue('isSizeAvailable', true)
                tempSizeList = [{ label: 'Custom', value: 'Custom' }]
                setSizeList(tempSizeList)
            }
        }
    }

    const moistureSelectionFunction = (formikValues, setFieldValue, moistureValue, palletSpecificationData, editFlag) => {
        resetFieldValues(setFieldValue, 'withoutPalletTypeAndMoisture', editFlag)

        let conditionRadioValue = formikValues.conditionRadioValue
        if (props?.editResponse?.palletDetails?.condition && editFlag) {
            if (props?.editResponse?.palletDetails?.condition[0] === 'RECYCLED') conditionRadioValue = 'recycled'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'NEW') conditionRadioValue = 'newCondition'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'COMBO') conditionRadioValue = 'combo'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'CORES') conditionRadioValue = 'cores'
        }
        let palletType = formikValues.palletType
        if (props?.editResponse?.palletDetails?.palletType && editFlag) {
            if (props?.editResponse?.palletDetails?.palletType === "Euro Pallet" || props?.editResponse?.palletDetails?.palletType === "EUROPALLET") {
                palletType = 'euroPallet'
            } else {
                palletType = props?.editResponse?.palletDetails?.palletType.toLowerCase()
            }
        }
        let materialRadioValue = formikValues.materialRadioValue
        if (props?.editResponse?.palletDetails?.material && editFlag) {
            materialRadioValue = props?.editResponse?.palletDetails?.material.toLowerCase()
        }

        if (palletSpecificationData || palletSpecificationDetails) {
            let tempSpecDetails
            if (palletSpecificationData && editFlag)
                tempSpecDetails = palletSpecificationData[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails
            else tempSpecDetails = palletSpecificationDetails[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails

            let tempSizeList = tempSpecDetails?.filter(val => (val.size && val.size !== '')).map(val => val.size)
            if (tempSizeList && tempSizeList?.length > 0) {
                setFieldValue('isSizeAvailable', true)
                tempSizeList = new Set(tempSizeList)
                tempSizeList = Array.from(tempSizeList)
                tempSizeList = tempSizeList.map(data => ({ label: data, value: data }))
                setSizeList(tempSizeList)

                if (props?.editResponse?.palletDetails?.size && editFlag) {
                    setFieldValue("size", props?.editResponse?.palletDetails?.size)
                    sizeSelectionFunction(formikProps.values, formikProps.setFieldValue, props?.editResponse?.palletDetails?.size, palletSpecificationData, editFlag)
                }
            }
        }
    }

    const sizeSelectionFunction = (formikValues, setFieldValue, sizeValue, palletSpecificationData, editFlag) => {
        resetFieldValues(setFieldValue, 'withoutPalletTypeMoistureAndSize', editFlag)
        let conditionRadioValue = formikValues.conditionRadioValue
        if (props?.editResponse?.palletDetails?.condition && editFlag) {
            if (props?.editResponse?.palletDetails?.condition[0] === 'RECYCLED') conditionRadioValue = 'recycled'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'NEW') conditionRadioValue = 'newCondition'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'COMBO') conditionRadioValue = 'combo'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'CORES') conditionRadioValue = 'cores'
        }

        let palletType = formikValues.palletType
        if (props?.editResponse?.palletDetails?.palletType && editFlag) {
            if (props?.editResponse?.palletDetails?.palletType === "Euro Pallet" || props?.editResponse?.palletDetails?.palletType === "EUROPALLET") {
                palletType = 'euroPallet'
            } else {
                palletType = props?.editResponse?.palletDetails?.palletType.toLowerCase()
            }
        }

        let materialRadioValue = formikValues.materialRadioValue
        if (props?.editResponse?.palletDetails?.material && editFlag) {
            materialRadioValue = props?.editResponse?.palletDetails?.material.toLowerCase()
        }

        if (props?.editResponse?.palletDetails?.height && editFlag)
            setFieldValue("height", props?.editResponse?.palletDetails?.height)
        if (props?.editResponse?.palletDetails?.width && editFlag)
            setFieldValue("width", props?.editResponse?.palletDetails?.width)
        if (props?.editResponse?.palletDetails?.length && editFlag)
            setFieldValue("length", props?.editResponse?.palletDetails?.length)

        if (palletSpecificationDetails || palletSpecificationData) {
            // let tempSpecDetails = palletSpecificationDetails[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails
            let tempSpecDetails
            if (palletSpecificationData && editFlag)
                tempSpecDetails = palletSpecificationData[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails
            else tempSpecDetails = palletSpecificationDetails[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails

            let tempGradeList
            if (palletSpecificationData && editFlag)
                tempGradeList = tempSpecDetails?.filter(val => (val.grade && val.grade !== '' && val.size === sizeValue)).map(val => val.grade)
            else tempGradeList = tempSpecDetails?.filter(val => (val.grade && val.grade !== '' && val.size === sizeValue.value)).map(val => val.grade)

            if (tempGradeList && tempGradeList?.length > 0) {
                setFieldValue('isGradeAvailable', true)
                tempGradeList = new Set(tempGradeList)
                tempGradeList = Array.from(tempGradeList)
                tempGradeList = tempGradeList.map(data => ({ label: data, value: data }))
                setGradeList(tempGradeList)

                if (props?.editResponse?.palletDetails?.grade && editFlag) {
                    setFieldValue("grade", props?.editResponse?.palletDetails?.grade)
                    setFieldValue("heatTreated", props?.editResponse?.palletDetails?.heatTreared)
                    // gradeSelectionFunction(formikProps.values, formikProps.setFieldValue, props?.editResponse?.palletDetails?.grade, palletSpecificationData,editFlag)
                }
            }
            let specFileArrayTemp = tempSpecDetails?.filter(val => val.size === sizeValue.value)
            if (specFileArrayTemp && specFileArrayTemp?.length > 0) {
                if (sizeValue.label !== 'Custom' && (!tempGradeList || tempGradeList?.length === 0) && specFileArrayTemp[0].file?.indexOf('Custom') === -1) {
                    let tempFilesObj = { label: specFileArrayTemp[0].file, value: specFileArrayTemp[0].file }
                    setDefaultSpecFile([tempFilesObj])
                    setUploadedSpecFileArr()
                    if (specFileArrayTemp[0].image) props.defaultPostImageCallBack(specFileArrayTemp[0].image)
                } else {
                    if (!editFlag) setEditFlag(false)
                    setDefaultSpecFile()
                    setUploadedSpecFileArr()
                    props.setPalletSpecFilesData()
                }
                let maxQuantity = specFileArrayTemp[0]?.quantity
                if (maxQuantity) {
                    setFieldValue('quantityMaxValue', parseInt(maxQuantity))
                    setFieldValue('editFlag', false)
                    setFieldValue('quantityPerLot', parseInt(maxQuantity))
                }
            }
            if (formikValues.conditionRadioValue !== 'cores') setFieldValue('showHeatTreated', true)

            if (props?.editResponse?.palletDetails?.heatTreared && editFlag)
                setFieldValue("heatTreated", props?.editResponse?.palletDetails?.heatTreared)

        }
    }

    const gradeSelectionFunction = (formikValues, setFieldValue, gradeValue, palletSpecificationData) => {
        setDefaultSpecFile()
        props.defaultPostImageCallBack()
        setUploadedSpecFileArr()

        let conditionRadioValue = formikValues.conditionRadioValue
        if (props?.editResponse?.palletDetails?.condition && editFlag) {
            if (props?.editResponse?.palletDetails?.condition[0] === 'RECYCLED') conditionRadioValue = 'recycled'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'NEW') conditionRadioValue = 'newCondition'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'COMBO') conditionRadioValue = 'combo'
            else if (props?.editResponse?.palletDetails?.condition[0] === 'CORES') conditionRadioValue = 'cores'
        }

        let palletType = formikValues.palletType
        if (props?.editResponse?.palletDetails?.palletType && editFlag) {
            if (props?.editResponse?.palletDetails?.palletType === "Euro Pallet" || props?.editResponse?.palletDetails?.palletType === "EUROPALLET") {
                palletType = 'euroPallet'
            } else {
                palletType = props?.editResponse?.palletDetails?.palletType.toLowerCase()
            }
        }

        let materialRadioValue = formikValues.materialRadioValue
        if (props?.editResponse?.palletDetails?.material && editFlag) {
            materialRadioValue = props?.editResponse?.palletDetails?.material.toLowerCase()
        }
        if (palletSpecificationData || palletSpecificationDetails) {
            let tempSpecDetails
            if (palletSpecificationData && editFlag)
                tempSpecDetails = palletSpecificationData[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails
            else tempSpecDetails = palletSpecificationDetails[materialRadioValue]?.condition[conditionRadioValue][palletType]?.palletSpecificDetails

            let specFileArrayTemp;
            if (palletSpecificationData && editFlag) {
                specFileArrayTemp = tempSpecDetails?.filter(val => val.grade === gradeValue)
            } else {
                specFileArrayTemp = tempSpecDetails?.filter(val => val.grade === gradeValue.value)
            }
            // let specFileArrayTemp = tempSpecDetails?.filter(val => val.grade === gradeValue.value)
            if (specFileArrayTemp && specFileArrayTemp?.length > 0 && specFileArrayTemp[0].file?.indexOf('Custom') === -1) {
                let tempFilesObj = { label: specFileArrayTemp[0].file, value: specFileArrayTemp[0].file }
                setDefaultSpecFile([tempFilesObj])
                setUploadedSpecFileArr()
                if (specFileArrayTemp[0].image) props.defaultPostImageCallBack(specFileArrayTemp[0].image)
            }
        }

    }

    const downloadSpecFile = fileValue => {
        const fileUrl = process.env.REACT_APP_API_URL + '/order/image/' + fileValue;
        window.open(fileUrl)
    }

    const hardOrSoftWoodDiv = () => {
        return (
            <div className="row mb-2 mt-2">
                {hardOrSoftWoodArray &&
                    hardOrSoftWoodArray.map((value, index) => (
                        <div className='col-md-4'>
                            <HardSoftWoodWrapper>
                                <Field
                                    component={RadioButton}
                                    name="hardOrSoftWood"
                                    id={value}
                                    defaultValue={hardOrSoftWoodArray[0]}
                                    onSelect={(e) => {
                                        // setEditFlag(false)
                                        // props.setPalletSpecFilesData()
                                        let tempValue = hardOrSoftWoodValue === e.target?.value ? '' : e.target?.value
                                        formikProps.setFieldValue('hardOrSoftWood', tempValue)
                                        setHardOrSoftWoodValue(tempValue)
                                    }}
                                    label={value}
                                />
                            </HardSoftWoodWrapper>
                        </div>
                    ))}
            </div>
        );
    };

    // const capitalize = (s) => {
    //     if (typeof s !== 'string')
    //       return ''
    //     return s.charAt(0).toUpperCase() + s.slice(1)
    //   }
    return (
        <>
            <div>
                <div className={`row`}>
                    <div className={`col-md-12`}>
                        <p>Material<span className='mandatorystar'>&#42;</span></p>
                        <div className={`row`}>
                            {materialOptions.map((value, index) => (
                                <div className={`col-md-4`} key={index}>
                                    <Field
                                        component={RadioButton}
                                        name="materialRadioValue"
                                        id={value.value}
                                        defaultValue={materialOptions[0].value}
                                        onSelect={(e) => { materialSelectFunction(formikProps.setFieldValue, e.target.value) }}
                                        label={value.label}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {formikProps.values?.materialRadioValue !== 'other' && <div className={`row`}>
                    {conditionOptions?.length > 0 &&
                        <div className={`col-md-12`}>
                            <p>Condition<span className='mandatorystar'>&#42;</span></p>
                            <div className={`row`}>
                                {conditionOptions.map((value, index) => (
                                    <div className={`col-md-2`} key={index}>
                                        <Field
                                            component={RadioButton}
                                            name="conditionRadioValue"
                                            id={value.value}
                                            defaultValue={conditionOptions[0].value}
                                            onSelect={(e) => conditionSelectFunction(formikProps.setFieldValue, e.target.value)}
                                            label={value.label}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                </div>}

                {(formikProps.values?.materialRadioValue === 'wood' && formikProps?.values?.conditionRadioValue === 'newCondition') && hardOrSoftWoodDiv()}

                {formikProps.values?.materialRadioValue === 'wood' &&
                    <>
                        <div className={`row mt-1 palletspec-style`}>
                            <div className={`col-md-4`}>
                                <p>Pallet Type<span className='mandatorystar'>&#42;</span></p>
                                <Select
                                    name="palletType"
                                    data={palletTypeList}
                                    disabled={palletTypeList.length === 0}
                                    placeholder="Select Pallet Type"
                                    onChangeHandler={(data) => palletTypeSelectionFunction(formikProps.values, formikProps.setFieldValue, data)}
                                />
                            </div>
                            {(moistureList && moistureList?.length > 0) &&
                                <div className={`col-md-4`}>
                                    <p>Moisture<span className='mandatorystar'>&#42;</span></p>
                                    <Select
                                        name="moisture"
                                        data={moistureList}
                                        disabled={moistureList.length === 0}
                                        placeholder="Select Mositure"
                                        onChangeHandler={(data) => moistureSelectionFunction(formikProps.values, formikProps.setFieldValue, data)}
                                    />
                                </div>
                            }
                            <div className={`col-md-4`}>
                                <p>Size<span className='mandatorystar'>&#42;</span></p>
                                <Select
                                    name="size"
                                    data={sizeList}
                                    disabled={sizeList.length === 0}
                                    placeholder="Select Size"
                                    onChangeHandler={(data) => sizeSelectionFunction(formikProps.values, formikProps.setFieldValue, data)}
                                />
                            </div>
                            {(gradeList && gradeList?.length > 0) &&
                                <div className={`col-md-4`}>
                                    <p>Grade<span className='mandatorystar'>&#42;</span></p>
                                    <Select
                                        name="grade"
                                        data={gradeList}
                                        disabled={gradeList.length === 0}
                                        placeholder="Select Grade"
                                        onChangeHandler={(data) => gradeSelectionFunction(formikProps.values, formikProps.setFieldValue, data)}
                                    />
                                </div>
                            }
                        </div>
                    </>}

            </div>

            {(formikProps.values?.materialRadioValue === 'plastic' || formikProps.values?.materialRadioValue === 'other' || formikProps.values?.size === 'Custom') &&
                <div className={`row mt-1`}>
                    <div className={`col-md-4`}>
                        <p>{`Length (Inch)`}<span className='mandatorystar'>&#42;</span></p>
                        <NumberInput
                            name="length"
                            showErrorMessages={true}
                            placeholder='Length'
                            decimalScale={2}
                            maxLength={6}
                            maxAllowedValueLimit={9999}
                            onChangeHandler={(value) => { }}
                        />
                    </div>
                    <div className={`col-md-4`}>
                        <p>{`Width (Inch)`}<span className='mandatorystar'>&#42;</span></p>
                        <NumberInput
                            name="width"
                            placeholder='Width'
                            decimalScale={2}
                            showErrorMessages={true}
                            maxLength={6}
                            maxAllowedValueLimit={9999}
                            onChangeHandler={(value) => { }}
                        />
                    </div>
                    <div className={`col-md-4`}>
                        <p>{`Height (Inch)`}<span className='mandatorystar'>&#42;</span></p>
                        <NumberInput
                            name="height"
                            placeholder='Height'
                            decimalScale={2}
                            showErrorMessages={true}
                            maxLength={6}
                            maxAllowedValueLimit={9999}
                            onChangeHandler={(value) => { }}
                        />
                    </div>
                </div>
            }

            {formikProps.values?.showHeatTreated &&
                <div className="row mt-1">
                    <div className={`col-md-4`}>
                        <CheckboxInput
                            name='heatTreated'
                            label='Heat Treated'
                            // checked={props?.editResponse?.palletDetails?.heatTreared?true:false}
                            checked={formikProps.values.heatTreated}
                            handleSelect={(val, label, flag) => {
                            }}
                        />
                    </div>
                </div>
            }

            {(defaultSpecFile && defaultSpecFile?.length > 0 && !uploadedSpecFileArr) &&
                <div style={{ cursor: 'pointer' }} onClick={() => downloadSpecFile(defaultSpecFile[0]?.value)}>
                    <img src={UploadDummy} alt="upload Dummy" />
                    <span style={{ fontSize: '13px', marginTop: '7px', marginLeft: '4px' }}>{defaultSpecFile[0] && defaultSpecFile[0]?.label}</span>
                </div>
            }

            {/* {formikProps.values?.materialRadioValue}--===-{capitalize(props?.editResponse?.palletDetails?.material.toLowerCase())} */}
            {props?.editResponse && props?.editResponse?.specificationFiles?.length > 0 && !defaultSpecFile && defaultSpecFile?.length !== 0 && editFlag &&
                <>{props?.editResponse?.specificationFiles.map((items, i) => (
                    <div style={{ cursor: 'pointer' }} onClick={() => downloadSpecFile(props?.editResponse?.specificationFiles[i]?.fileName)}>
                        <img src={UploadDummy} alt="upload Dummy" />
                        <span style={{ fontSize: '13px', marginTop: '7px', marginLeft: '4px' }}>{props?.editResponse?.specificationFiles[i]?.orignalFileName}</span>
                        {/* {props?.editResponse?.specificationFiles}
                    {items} */}
                    </div>
                ))}</>
            }
            <div style={{ marginTop: '20px', position: 'relative' }}>
                <UploadSpecification
                    name="uploadSpecificationImgLoad"
                    props={formikProps}
                    ProfileName=""
                    CompanyName=""
                    pageType=""
                    fileArr={fileArr}
                    imageLoadCallBack={(imageArr) => {
                        setEditFlag(false)
                        setUploadedSpecFileArr(imageArr)
                    }}
                    callBackFun={(imageArr) => {
                        setUploadedSpecFileArr(imageArr)
                    }}
                />
                <span style={{ left: '160px', top: '6px', position: 'absolute', color: '#fff' }} className='mandatorystar'>&#42;</span>
            </div>
        </>
    );
}


export default PalletSpecDetails;

const HardSoftWoodWrapper = styled.div`
  margin-right: 55px;
  .radio-checkmark{
      width: 18px;
      height: 18px;
      border-radius: 0px;
    }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 0px;
    }
  .radio-container {
    span {
      white-space : nowrap;
    }
  }
`